import * as React from 'react';

/**
 * @description CardTerminal icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CardTerminal } from '@sravni/design-system-icons'
 *
 * <CardTerminal />
 * ```
 */
const CardTerminal = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "CardTerminal", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M17.403 17.143H2.598c-.526 0-1.17-.579-1.17-1.072v-1.428c0-.493.644-1.072 1.17-1.072h14.805c.526 0 1.169.579 1.169 1.072v1.428c0 .493-.643 1.072-1.17 1.072ZM1.786 2.857h4.286M1.786 5.714H3.93M1.786 8.571H2.5M13.072 13.571l4.964-4.852a1.757 1.757 0 0 0 0-2.525l-2.878-2.813a1.857 1.857 0 0 0-2.584 0l-5.61 5.483a1.757 1.757 0 0 0 0 2.525l2.233 2.182M7.719 12.125l8.195-8.01", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { CardTerminal };
//# sourceMappingURL=CardTerminal.js.map
